import React, { useEffect } from "react";

const UseFormCheckbox = ({
  title,
  field,
  register,
  watch,
  errors,
  setValue,
  disable = false,
}) => {
  const value = watch(field);

  useEffect(() => {
    register(field);
  }, [field, register]);

  return (
    <div className="form-group">
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={field}
          checked={value}
          onChange={(e) => {
            setValue(field, e.target.checked);
          }}
          disabled={disable}
        />
        <label className="form-check-label" htmlFor={field}>
          {title}
        </label>
      </div>
      <div className="invalid-feedback">{errors?.[field]?.message}</div>
    </div>
  );
};

export default UseFormCheckbox;
